(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeroVideos() {
    document.querySelectorAll('.hero-home').forEach(function(hero) {
      const video = hero.querySelector('.hero-home__video');
      const button = hero.querySelector('.hero-home__video-toggle');
      if (!video || !button || button.dataset.initialised) return;
      button.dataset.initialised = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function updateButton() {
        button.textContent = video.paused ? 'Play video' : 'Pause video';
        button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
      }
      function applyMotionPreference() {
        if (reducedMotion.matches) video.pause();
        button.hidden = reducedMotion.matches;
        updateButton();
      }
      video.muted = true;
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      button.addEventListener('click', function() {
        if (video.paused) video.play().catch(updateButton);
        else video.pause();
      });
      reducedMotion.addEventListener('change', applyMotionPreference);
      applyMotionPreference();
    });
  }
  initialiseHeroVideos();
  document.addEventListener('shopify:section:load', initialiseHeroVideos);

  } catch(e) { console.error(e); }
})();
})();
